module.exports = __webpack_public_path__ + "img/virtual2.0ca74be2.png";